import { render } from "./CallCenterSettings.vue?vue&type=template&id=37ad4511"
import script from "./CallCenterSettings.vue?vue&type=script&lang=js"
export * from "./CallCenterSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__